<template>
    <div class="block-editor ai-classification payload" v-if="clone">
        <strong>Sınıflandırılacak Ifade: </strong>
        <div class="says">
            <TiptapEditor
                :show-emoji="true"
                :show-attributes="true"
                placeholder="Kullanıcı mesajı veya sınıflandırma yapılacak metni giriniz"
                v-model="clone.message"
                :key="'tiptap-prompt' + renderKey"
            />
        </div>
        <strong>Sınıflandırma:</strong>
        <div class="says" v-for="(tag, i) in clone.tags" :key="i">
            <TiptapEditor
                :show-emoji="true"
                :show-attributes="true"
                placeholder="Sınıflandırma"
                :value="tag"
                @input="changeTags(i, $event)"
            />
            <SupsisButton danger @click="removeTag(i)" small>
                <span class="material-icons">delete</span>
            </SupsisButton>
        </div>
        <a-divider />
        <SupsisButton primary @click="addTag"><span class="material-icons">add</span> Sınıflandırma Ekle</SupsisButton>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import log2 from "../../../../../../utils/log2";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";

const log = log2("AIClassification");
export default {
    name: "AIClassification",
    components: { TiptapEditor, SupsisButton },
    props: {
        value: {
            type: Object,
            default: () => ({
                message: "",
                tags: [],
            }),
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            renderKey: 0,
        };
    },
    watch: {
        clone: {
            handler(newValue) {
                this.$emit("input", newValue);
            },
            deep: true,
        },
    },
    methods: {
        changeTags(index, value) {
            this.clone = {
                message: this.clone.message,
                tags: this.clone.tags.map((tag, i) => {
                    if (index === i) tag = value;
                    return tag;
                }),
            };
        },
        addTag() {
            this.clone.tags.push(`Class ${this.clone.tags.length + 1}`);
            this.renderKey++;
        },
        removeTag(index) {
            this.clone.tags.splice(index, 1);
            this.renderKey++;
        },
    },
};
</script>

<style lang="scss">
.block-editor.ai-classification {
    padding: 30px 30px 90px;

    .says {
        display: flex;
        gap: 5px;
        align-items: center;
        flex-direction: row !important;

        .supsis-button {
            background: transparent !important;
            color: red !important;
            border: none !important;
        }
    }

    .ai-classification-header {
        align-items: center;
        display: flex;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
        margin-bottom: 16px;

        .material-icons {
            margin-right: 6px;
        }
    }

    .editable-editor-wrapper {
        border: 1px solid white;
        border-radius: 13px;
        //max-height: 50px;

        .editable-editor {
            //max-height: 50px;

            .ProseMirror {
                //max-height: 50px;
                overflow-y: auto;
            }
        }

        &.focused {
            border-color: #006cff;
        }

        &:hover {
            border-color: #006cff;
        }
    }
}
</style>
